import type { I18n } from '.'

const zhCN: I18n = {
  /* Editor */
  placeholder: '键入内容...',
  noComment: '「此时无声胜有声」',
  send: '发送',
  signIn: '登录',
  signUp: '注册',
  save: '保存',
  nick: '昵称',
  email: '邮箱',
  link: '网址',
  emoticon: '表情',
  preview: '预览',
  uploadImage: '上传图片',
  uploadFail: '上传失败',
  commentFail: '评论失败',
  restoredMsg: '内容已自动恢复',
  onlyAdminCanReply: '仅管理员可评论',
  uploadLoginMsg: '填入你的名字邮箱才能上传哦',

  /* List */
  counter: '{count} 条评论',
  sortLatest: '最新',
  sortOldest: '最早',
  sortBest: '最热',
  sortAuthor: '作者',
  openComment: '打开评论',
  closeComment: '关闭评论',
  listLoadFailMsg: '无法获取评论列表数据',
  listRetry: '点击重新获取',
  loadMore: '加载更多',

  /* Comment */
  admin: '管理员',
  reply: '回复',
  voteUp: '赞同',
  voteDown: '反对',
  voteFail: '投票失败',
  readMore: '阅读更多',
  actionConfirm: '确认操作',
  collapse: '折叠',
  collapsed: '已折叠',
  collapsedMsg: '该评论已被系统或管理员折叠',
  expand: '展开',
  approved: '已审',
  pending: '待审',
  pendingMsg: '审核中，仅本人可见。',
  edit: '编辑',
  editCancel: '取消编辑',
  delete: '删除',
  deleteConfirm: '确认删除',
  pin: '置顶',
  unpin: '取消置顶',

  /* Time */
  seconds: '秒前',
  minutes: '分钟前',
  hours: '小时前',
  days: '天前',
  now: '刚刚',

  /* Checker */
  adminCheck: '键入密码来验证管理员身份：',
  captchaCheck: '键入验证码继续：',
  confirm: '确认',
  cancel: '取消',

  /* Sidebar */
  msgCenter: '通知中心',
  ctrlCenter: '控制中心',

  /* Auth */
  userProfile: '个人资料',
  noAccountPrompt: '没有账号？',
  haveAccountPrompt: '已有账号？',
  forgetPassword: '忘记密码',
  resetPassword: '重置密码',
  changePassword: '修改密码',
  confirmPassword: '确认密码',
  passwordMismatch: '两次输入的密码不一致',
  verificationCode: '验证码',
  verifySend: '发送验证码',
  verifyResend: '重新发送',
  waitSeconds: '等待 {seconds}秒',
  emailVerified: '邮箱已验证',
  password: '密码',
  username: '用户名',
  nextStep: '下一步',
  skipVerify: '跳过验证',
  logoutConfirm: '确定要退出登录吗？',
  accountMergeNotice: '您的电子邮件下有多个不同 ID 的账户。',
  accountMergeSelectOne: '请选择将所有数据合并到其中的一个。',
  accountMergeConfirm: '所有数据将合并到 ID 为 {id} 的账户中。',
  dismiss: '忽略',
  merge: '合并',

  /* General */
  frontend: '前端',
  backend: '后端',
  loading: '加载中',
  loadFail: '加载失败',
  editing: '修改中',
  editFail: '修改失败',
  deleting: '删除中',
  deleteFail: '删除失败',
  reqGot: '请求响应',
  reqAborted: '请求超时或意外终止',
  updateMsg: '请更新 Artalk {name} 以获得更好的体验！',
  currentVersion: '当前版本',
  ignore: '忽略',
  open: '打开',
  openName: '打开{name}',
}

export default zhCN
